"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uuid = require("uuid");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Utils = {
  getNewId: function getNewId() {
    return (0, _uuid.v4)();
  },
  has: function has(object, key) {
    return object ? hasOwnProperty.call(object, key) : false;
  },
  entityNameCutHelper: function entityNameCutHelper(longName) {
    var words = longName.split(".");
    var reversedWords = words.slice().reverse();
    return reversedWords[0];
  },
  validURL: function validURL(url) {
    try {
      new URL(url);
    } catch (e) {
      return false;
    }

    return true;
  },
  saveDataForConsumption: function saveDataForConsumption(data) {
    return data.map(function (field) {
      var ff = field.type === "radio" ? Object.assign({}, field.validations) : Object.assign({}, field.validations, field.attributes);
      ff.name = field.name;
      ff.uid = field.i;
      ff.elementType = field.type;
      ff.dependencies = field.dependencies;
      ff.source = field.source;
      ff.disableDependency = field.disableDependency || null;
      ff.disableDependencyExpectedValue = field.disableDependencyExpectedValue || null;
      ff.isActiveCustomStyles = field.isActiveCustomStyles || false;
      ff.customStyles = field.customStyles || {};

      if (ff.elementType === "select") {
        ff.isChild = field.isChild;
      }

      if (ff.elementType === "date") {
        ff.isBirthday = field.isBirthday;
      }

      if (ff.elementType !== "accordion" || ff.elementType !== "button") {
        ff.label = field.label || field.attributes.label;
        ff.childAccordion = field.childAccordion;
      }

      if (ff.elementType === "accordion") {
        ff.childs = field.childs;
      }

      if (ff.elementType === "radio" || ff.elementType === "checkbox") {
        ff.label = field.label;
        ff.required = field.required;
        ff.value = field.value;

        if (ff.elementType === "radio") {
          ff.isBtn = field.isBtn;
          ff.color = field.color;
        }

        ff.attributes = _toConsumableArray(field.attributes);
      }

      if (ff.elementType !== "button") {
        ff.type = {
          multiple: false,
          name: ff.elementType === "radio" || ff.elementType === "checkbox" ? ff.elementType : field.attributes.type
        };
      }

      ff.layout = {
        h: field.h,
        maxH: field.maxH,
        minH: field.minH,
        w: field.w,
        x: field.x,
        y: field.y
      };
      return ff;
    });
  }
};
var _default = Utils;
exports.default = _default;